import {z} from "zod/v4-mini"
import type {TemplateNode} from "#template/template-node/template-node"
import type {TemplateListNodeDefinition, TemplateListNodeParameters} from "#template/template-list-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"
import type {VisitorNodeResult} from "#template/template-node/types"

export const getTemplateListNodeReturns = <ItemType extends TemplateNode>() =>
    getTemplateNodeReturns<TemplateListNodeParameters<ItemType>>() as z.ZodMiniType<VisitorNodeResult<TemplateListNodeParameters<ItemType>>, unknown>

export const templateListNodeDefinition = <ItemType extends TemplateNode>(nodeClass: string, itemSchema: z.ZodMiniType<ItemType, ItemType>) => {
    const result: TemplateListNodeDefinition<ItemType> = {
        nodeClass,
        validation: {
            parameters: z.object({list: z.array(itemSchema)}),
            returns: getTemplateListNodeReturns<ItemType>(),
        },
    }
    return result
}
